import React from 'react';
import { Icon, Modal } from 'Components';
import { useTranslation } from 'react-i18next';
import Button from 'LearningManager/components/Button';
import styles from './AssignmentSuccessModal.module.scss';

interface AssignmentSuccessModalProps {
	visible: boolean;
	onClose: () => void;
	isEditMode?: boolean;
}

const AssignmentSuccessModal: React.FC<AssignmentSuccessModalProps> = ({
	visible,
	onClose,
	isEditMode = false
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			className={styles.modalWidth}
			visible={visible}
			onCancel={onClose}
			footer={
				<div className={styles.footer}>
					<Button
						size="small"
						className="cta-prominent"
						onClick={onClose}
					>
						{t('learning.createAssignment.successModal.viewAssignments')}
					</Button>
				</div>
			}
			centered
			maskClosable
		>
			<div className={styles.container}>
				<div className={styles.iconWrap}>
					<div className={styles.check}>
						<Icon type="check" role="img" />
					</div>
				</div>

				<div className={styles.title}>
					{isEditMode
						? t('learning.createAssignment.successModal.updatedTitle')
						: t('learning.createAssignment.successModal.assignedTitle')}
				</div>

				<div className={styles.description}>
					{isEditMode
						? t('learning.createAssignment.successModal.updatedDescription')
						: t(
								'learning.createAssignment.successModal.assignedDescription'
							)}
				</div>
			</div>
		</Modal>
	);
};

export default AssignmentSuccessModal;